import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { GroupProtectedRoute } from '../../components/auth/GroupProtectedRoute';
import { FEATURE_GROUPS, COMMUNICATION_ADMIN_GROUP_ID, COMMUNICATION_SUPERVISOR_GROUP_ID } from '../../features.config';
import { MyCallsPage } from './pages/MyCallsPage';
import { AdminPage } from './pages/AdminPage';
import { getMe } from './api';

// Calls /communication/me once on entry, which auto-provisions the caller's Agent
// record. Page-level data calls (e.g. My Calls) 403 until that Agent row exists, so
// we hold off rendering the pages until provisioning has completed.
const CommunicationArea: React.FC = () => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    getMe().finally(() => setReady(true));
  }, []);

  if (!ready) return null;

  return (
    <Routes>
      <Route index element={<MyCallsPage />} />
      <Route path="admin" element={<AdminPage />} />
    </Routes>
  );
};

export const CommunicationRoutes: React.FC = () => (
  <GroupProtectedRoute
    requiredGroup={FEATURE_GROUPS.communication}
    allowGroups={[COMMUNICATION_ADMIN_GROUP_ID, COMMUNICATION_SUPERVISOR_GROUP_ID]}
  >
    <CommunicationArea />
  </GroupProtectedRoute>
);
